module.exports = __webpack_public_path__ + "img/menu.30c99577.svg";